module.exports = __webpack_public_path__ + "/dist/assets/fonts/Vazir-FD.woff2";